import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "../../config";

const baseQuery = fetchBaseQuery({
  baseUrl: getApiBaseUrl(),
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const user = getState().user?.currentUser;
    if (user?.id) {
      headers.set("userid", user.id);
    }
    return headers;
  },
});

export const faqApi = createApi({
  reducerPath: "faqApi",
  baseQuery,
  tagTypes: ["Faqs"],
  endpoints: (builder) => ({
    getFaqs: builder.query({
      query: (category) => {
        const params = category ? `?category=${category}` : "";
        return `/faqs${params}`;
      },
      transformResponse: (response) => response.data || response,
      providesTags: ["Faqs"],
    }),
    getFaqById: builder.query({
      query: (id) => `/faqs/${id}`,
      transformResponse: (response) => response.data || response,
      providesTags: (result, error, id) => [{ type: "Faqs", id }],
    }),
    createFaq: builder.mutation({
      query: (faqData) => ({
        url: "/faqs",
        method: "POST",
        body: faqData,
      }),
      invalidatesTags: ["Faqs"],
    }),
    updateFaq: builder.mutation({
      query: ({ id, ...faqData }) => ({
        url: `/faqs/${id}`,
        method: "PUT",
        body: faqData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Faqs", id }, "Faqs"],
    }),
    deleteFaq: builder.mutation({
      query: (id) => ({
        url: `/faqs/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Faqs"],
    }),
  }),
});

export const {
  useGetFaqsQuery,
  useGetFaqByIdQuery,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useDeleteFaqMutation,
} = faqApi;